export const environment = {
  production: true,
  hmr: false,
  apiUrl: "https://dokutool.kinderfreunde-steiermark.at",
  version: "{git-hash}",
};
